import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { font } from 'assets/themes/theme-default'

const Title = styled.div`
  border-width: 0px;
  border-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${props => props.theme.colors.color2.bg};
  font-size: ${font.size.lg};
  font-weight: ${font.weight.bold};
  margin-bottom: 25px;
  padding: 0 0 0 5px;
`

const FilterTitle = props => {
  const { label } = props
  return (
    <Title {...props} data-test="component-stock-vehicles-list-filters-title">
      {label}
    </Title>
  )
}

FilterTitle.propTypes = {
  label: PropTypes.string.isRequired
}

export default FilterTitle
